import { PureComponent } from "react";
import { bool, func, string } from "prop-types";

import { SITE_TITLE } from "../../constants";
import { colors } from "../../styles/Styles.variables";

import Checkbox from "../../styles/components/Checkbox";
import Group from "../form/components/Group";

class EmailOptIn extends PureComponent {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange() {
    const { emailOptIn, handleOptIn } = this.props;

    if (!!handleOptIn) {
      handleOptIn(!emailOptIn);
    }
  }

  render() {
    const { handleChange } = this;
    const { authenticated, color, emailOptIn, labelOffset, backgrcolor } =
      this.props;

    return !authenticated ? (
      <Group labelOffset={labelOffset}>
        <Checkbox
          backgrcolor={backgrcolor}
          checked={emailOptIn}
          color={!!colors[color] ? colors[color] : colors.white}
          id="email-opt-in"
          onChange={handleChange}
          upperCase={false}
          wrap={true}
        >
          Feel free to send me emails in the future about deals, sales and
          specials from {SITE_TITLE}.
        </Checkbox>
      </Group>
    ) : null;
  }
}

EmailOptIn.propTypes = {
  authenticated: bool,
  color: string,
  emailOptIn: bool,
  handleOptIn: func.isRequired,
  labelOffset: string,
  backgrcolor: string,
};

EmailOptIn.defaultProps = {
  authenticated: false,
  color: "white",
  emailOptIn: true,
  backgrcolor: null,
};

export default EmailOptIn;
